import cx from 'classnames';
import React from 'react';
import { ProviderName } from '../../../../../types/store';

interface ICloudProvider {
  className?: string;
  width?: number;
  cloudProvider: ProviderName;
}

const CLOUD_LOGOS: Record<ProviderName, string> = {
  [ProviderName.Alibaba]: 'Alibaba.png',
  [ProviderName.AWS]: 'AWS.png',
  [ProviderName.Azure]: 'Azure.png',
  [ProviderName.Equinix]: 'Equinix.png',
  [ProviderName.Google]: 'Google.png',
  [ProviderName.IBM]: 'IBM.png',
  [ProviderName.Office365]: 'Office365.png',
  [ProviderName.Oracle]: 'Oracle.png',
  [ProviderName.Salesforce]: 'Salesforce.png',
  [ProviderName.SSEET]: 'SSEET.png',
  [ProviderName.Other]: 'cloud.png',
  [ProviderName.NOT_DEFINED]: 'cloud.png',
};

export function logoForCloudProvider(cloudProvider: ProviderName) {
  return `/cloud_logos/${CLOUD_LOGOS[cloudProvider] || CLOUD_LOGOS[ProviderName.NOT_DEFINED]}`;
}

export const CloudProviderImage = ({ cloudProvider, className, width }: ICloudProvider) => (
  <img
    width={width || 90}
    src={logoForCloudProvider(cloudProvider)}
    className={cx(className, 'cloud_logos')}
    alt={cloudProvider}
  />
);
